import { render, staticRenderFns } from "./CrowdedBankingPage.vue?vue&type=template&id=43c0170e&scoped=true&"
import script from "./CrowdedBankingPage.vue?vue&type=script&lang=js&"
export * from "./CrowdedBankingPage.vue?vue&type=script&lang=js&"
import style0 from "./CrowdedBankingPage.vue?vue&type=style&index=0&id=43c0170e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c0170e",
  null
  
)

export default component.exports